/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PatchTeamsIdCaptainMutationRequest,
  PatchTeamsIdCaptainMutationResponse,
  PatchTeamsIdCaptainPathParams,
  PatchTeamsIdCaptain400,
  PatchTeamsIdCaptain401,
  PatchTeamsIdCaptain403,
  PatchTeamsIdCaptain500,
} from "../types/PatchTeamsIdCaptain.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const patchTeamsIdCaptainMutationKey = () =>
  [{ url: "/teams/:id/captain" }] as const;

export type PatchTeamsIdCaptainMutationKey = ReturnType<
  typeof patchTeamsIdCaptainMutationKey
>;

/**
 * @description Только текущий капитан команды может назначить нового капитана.
 * Новый капитан должен быть участником команды.
 * @summary Назначение нового капитана команды
 * {@link /teams/:id/captain}
 */
export async function patchTeamsIdCaptain(
  id: PatchTeamsIdCaptainPathParams["id"],
  data: PatchTeamsIdCaptainMutationRequest,
  config: Partial<RequestConfig<PatchTeamsIdCaptainMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchTeamsIdCaptainMutationResponse,
    ResponseErrorConfig<
      | PatchTeamsIdCaptain400
      | PatchTeamsIdCaptain401
      | PatchTeamsIdCaptain403
      | PatchTeamsIdCaptain500
    >,
    PatchTeamsIdCaptainMutationRequest
  >({
    method: "PATCH",
    url: `/teams/${id}/captain`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function patchTeamsIdCaptainMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchTeamsIdCaptainMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = patchTeamsIdCaptainMutationKey();
  return mutationOptions<
    ResponseConfig<PatchTeamsIdCaptainMutationResponse>,
    ResponseErrorConfig<
      | PatchTeamsIdCaptain400
      | PatchTeamsIdCaptain401
      | PatchTeamsIdCaptain403
      | PatchTeamsIdCaptain500
    >,
    {
      id: PatchTeamsIdCaptainPathParams["id"];
      data: PatchTeamsIdCaptainMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return patchTeamsIdCaptain(id, data, config);
    },
  });
}

/**
 * @description Только текущий капитан команды может назначить нового капитана.
 * Новый капитан должен быть участником команды.
 * @summary Назначение нового капитана команды
 * {@link /teams/:id/captain}
 */
export function usePatchTeamsIdCaptain<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PatchTeamsIdCaptainMutationResponse>,
      ResponseErrorConfig<
        | PatchTeamsIdCaptain400
        | PatchTeamsIdCaptain401
        | PatchTeamsIdCaptain403
        | PatchTeamsIdCaptain500
      >,
      {
        id: PatchTeamsIdCaptainPathParams["id"];
        data: PatchTeamsIdCaptainMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchTeamsIdCaptainMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchTeamsIdCaptainMutationKey();

  const baseOptions = patchTeamsIdCaptainMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PatchTeamsIdCaptainMutationResponse>,
    ResponseErrorConfig<
      | PatchTeamsIdCaptain400
      | PatchTeamsIdCaptain401
      | PatchTeamsIdCaptain403
      | PatchTeamsIdCaptain500
    >,
    {
      id: PatchTeamsIdCaptainPathParams["id"];
      data: PatchTeamsIdCaptainMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PatchTeamsIdCaptainMutationResponse>,
    ResponseErrorConfig<
      | PatchTeamsIdCaptain400
      | PatchTeamsIdCaptain401
      | PatchTeamsIdCaptain403
      | PatchTeamsIdCaptain500
    >,
    {
      id: PatchTeamsIdCaptainPathParams["id"];
      data: PatchTeamsIdCaptainMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PatchTeamsIdCaptainMutationResponse>,
    ResponseErrorConfig<
      | PatchTeamsIdCaptain400
      | PatchTeamsIdCaptain401
      | PatchTeamsIdCaptain403
      | PatchTeamsIdCaptain500
    >,
    {
      id: PatchTeamsIdCaptainPathParams["id"];
      data: PatchTeamsIdCaptainMutationRequest;
    },
    TContext
  >;
}
